(function () {
angular.module("gulp-routes", [])
.constant("Routes", [
  {
    "Name": "SortedCategoryPage",
    "Controller": "Category",
    "Action": "ShowSortedPage",
    "fr": {
      "URL": "{categoryName}-c-{categoryId:int}-{page:int}/{sortType:alpha}"
    },
    "en": {
      "URL": "{categoryName}-c-{categoryId:int}-{page:int}/{sortType:alpha}"
    }
  },
  {
    "Name": "SortedCategory",
    "Controller": "Category",
    "Action": "ShowSorted",
    "fr": {
      "URL": "{categoryName}-c-{categoryId:int}/{sortType:alpha}"
    },
    "en": {
      "URL": "{categoryName}-c-{categoryId:int}/{sortType:alpha}"
    }
  },
  {
    "Name": "CategoryPage",
    "Controller": "Category",
    "Action": "ShowPage",
    "fr": {
      "URL": "{categoryName}-c-{categoryId:int}-{page:int}"
    },
    "en": {
      "URL": "{categoryName}-c-{categoryId:int}-{page:int}"
    }
  },
  {
    "Name": "Category",
    "Controller": "Category",
    "Action": "Show",
    "fr": {
      "URL": "{categoryName}-c-{categoryId:int}"
    },
    "en": {
      "URL": "{categoryName}-c-{categoryId:int}"
    }
  },
  {
    "Name": "CategoryWithElasticSearch",
    "Controller": "Category",
    "Action": "ShowWithElasticSearch",
    "fr": {
      "URL": "{categoryName}-c-{categoryId:int}/es/{query}"
    },
    "en": {
      "URL": "{categoryName}-c-{categoryId:int}/es/{query}"
    }
  },
  {
    "Name": "SortedCategoryPageWithElasticSearch",
    "Controller": "Category",
    "Action": "ShowSortedPageWithElasticSearch",
    "fr": {
      "URL": "{categoryName}-c-{categoryId:int}/es/{query}-{page:int}/{sortType:alpha}"
    },
    "en": {
      "URL": "{categoryName}-c-{categoryId:int}/es/{query}-{page:int}/{sortType:alpha}"
    }
  },
  {
    "Name": "CategoryMessage",
    "Controller": "CategoryMessage",
    "Action": "Show",
    "fr": {
      "URL": "{categoryName}-cmsg-{categoryId:int}"
    },
    "en": {
      "URL": "{categoryName}-cmsg-{categoryId:int}"
    }
  },
  {
    "Name": "CategoryMessagePage",
    "Controller": "CategoryMessage",
    "Action": "ShowPage",
    "fr": {
      "URL": "{categoryName}-cmsg-{categoryId:int}-{page:int}"
    },
    "en": {
      "URL": "{categoryName}-cmsg-{categoryId:int}-{page:int}"
    }
  },
  {
    "Name": "Product",
    "Controller": "Product",
    "Action": "Show",
    "fr": {
      "URL": "{productName}-p-{productId:int}"
    },
    "en": {
      "URL": "{productName}-p-{productId:int}"
    }
  },
  {
    "Name": "Product1Attribute",
    "Controller": "Product",
    "Action": "Show1Attribute",
    "fr": {
      "URL": "{productName}-p-{productId:int}/{keyAttribute1}"
    },
    "en": {
      "URL": "{productName}-p-{productId:int}/{keyAttribute1}"
    }
  },
  {
    "Name": "Product2Attributes",
    "Controller": "Product",
    "Action": "Show2Attributes",
    "fr": {
      "URL": "{productName}-p-{productId:int}/{keyAttribute1}/{keyAttribute2}"
    },
    "en": {
      "URL": "{productName}-p-{productId:int}/{keyAttribute1}/{keyAttribute2}"
    }
  },
  {
    "Name": "Product3Attributes",
    "Controller": "Product",
    "Action": "Show3Attributes",
    "fr": {
      "URL": "{productName}-p-{productId:int}/{keyAttribute1}/{keyAttribute2}/{keyAttribute3}"
    },
    "en": {
      "URL": "{productName}-p-{productId:int}/{keyAttribute1}/{keyAttribute2}/{keyAttribute3}"
    }
  },
  {
    "Name": "ProductWithElasticSearch",
    "Controller": "Product",
    "Action": "ShowWithElasticSearch",
    "fr": {
      "URL": "{productName}-p-{productId:int}/es/{query}"
    },
    "en": {
      "URL": "{productName}-p-{productId:int}/es/{query}"
    }
  },
  {
    "Name": "Product1AttributeWithElasticSearch",
    "Controller": "Product",
    "Action": "Show1AttributeWithElasticSearch",
    "fr": {
      "URL": "{productName}-p-{productId:int}/{keyAttribute1}/es/{query}"
    },
    "en": {
      "URL": "{productName}-p-{productId:int}/{keyAttribute1}/es/{query}"
    }
  },
  {
    "Name": "Product2AttributesWithElasticSearch",
    "Controller": "Product",
    "Action": "Show2AttributesWithElasticSearch",
    "fr": {
      "URL": "{productName}-p-{productId:int}/{keyAttribute1}/{keyAttribute2}/es/{query}"
    },
    "en": {
      "URL": "{productName}-p-{productId:int}/{keyAttribute1}/{keyAttribute2}/es/{query}"
    }
  },
  {
    "Name": "Product3AttributesWithElasticSearch",
    "Controller": "Product",
    "Action": "Show3AttributesWithElasticSearch",
    "fr": {
      "URL": "{productName}-p-{productId:int}/{keyAttribute1}/{keyAttribute2}/{keyAttribute3}/es/{query}"
    },
    "en": {
      "URL": "{productName}-p-{productId:int}/{keyAttribute1}/{keyAttribute2}/{keyAttribute3}/es/{query}"
    }
  },
  {
    "Name": "Cart",
    "Controller": "Cart",
    "Action": "Index",
    "fr": {
      "URL": "panier"
    },
    "en": {
      "URL": "cart"
    }
  },
  {
    "Name": "CartOutdated",
    "Controller": "Cart",
    "Action": "Index",
    "fr": {
      "URL": "panier-expire"
    },
    "en": {
      "URL": "outdated-cart"
    }
  },
  {
    "Name": "CartIdentification",
    "Controller": "Cart",
    "Action": "Index",
    "fr": {
      "URL": "panier/identification"
    },
    "en": {
      "URL": "cart/authentification"
    }
  },
  {
    "Name": "CartShipping",
    "Controller": "Cart",
    "Action": "Index",
    "fr": {
      "URL": "panier/livraison"
    },
    "en": {
      "URL": "cart/delivery"
    }
  },
  {
    "Name": "CartPayment",
    "Controller": "Cart",
    "Action": "Index",
    "fr": {
      "URL": "panier/paiement"
    },
    "en": {
      "URL": "cart/payment"
    }
  },
  {
    "Name": "CartValidation",
    "Controller": "Cart",
    "Action": "Index",
    "fr": {
      "URL": "panier/validation"
    },
    "en": {
      "URL": "cart/validation"
    }
  },
  {
    "Name": "CartOnePageCheckout",
    "Controller": "Cart",
    "Action": "Index",
    "fr": {
      "URL": "commander"
    },
    "en": {
      "URL": "checkout"
    }
  },
  {
    "Name": "CartOnePageCheckoutPayment",
    "Controller": "Cart",
    "Action": "Index",
    "fr": {
      "URL": "retour-paiement"
    },
    "en": {
      "URL": "back-to-payment"
    }
  },
  {
    "Name": "CartPaymentAction",
    "Controller": "Payment",
    "Action": "Payment",
    "fr": {
      "URL": "paiement"
    },
    "en": {
      "URL": "payment"
    }
  },
  {
    "Name": "CartRecognition",
    "Controller": "Cart",
    "Action": "Recognition",
    "fr": {
      "URL": "reconnaissance-panier/{idFolder:int}/{token}"
    },
    "en": {
      "URL": "cart-recognition/{idFolder:int}/{token}"
    }
  },
  {
    "Name": "CartPaymentRedirect",
    "Controller": "Cart",
    "Action": "Redirect",
    "fr": {
      "URL": "redirection-panier-paiement"
    },
    "en": {
      "URL": "cart-payment-redirect"
    }
  },
  {
    "Name": "QuotationPaymentError",
    "Controller": "Quotation",
    "Action": "PaymentError",
    "fr": {
      "URL": "paiement/erreur/{idFolder:int}"
    },
    "en": {
      "URL": "payment/error/{idFolder:int}"
    }
  },
  {
    "Name": "CartPaymentError",
    "Controller": "Cart",
    "Action": "PaymentError",
    "fr": {
      "URL": "paiement/erreur"
    },
    "en": {
      "URL": "payment/error"
    }
  },
  {
    "Name": "QuickOrder",
    "Controller": "Cart",
    "Action": "QuickOrder",
    "fr": {
      "URL": "commande-par-reference"
    },
    "en": {
      "URL": "order-by-reference"
    }
  },
  {
    "Name": "AccountValidationPage",
    "Controller": "Authentication",
    "Action": "AccountValidationPage",
    "fr": {
      "URL": "validation-compte/validation/{EncryptedIdCard}"
    },
    "en": {
      "URL": "account-validation/validate/{EncryptedIdCard}"
    }
  },
  {
    "Name": "ResendAccountValidationEmail",
    "Controller": "AccountCreate",
    "Action": "ResendAccountValidationEmail",
    "fr": {
      "URL": "validation-compte/renvoi/{EncryptedIdCard}"
    },
    "en": {
      "URL": "account-validation/resend/{EncryptedIdCard}"
    }
  },
  {
    "Name": "AccountValidateEmailToken",
    "Controller": "Authentication",
    "Action": "AccountValidateEmailToken",
    "fr": {
      "URL": "identification/{validEmailToken}"
    },
    "en": {
      "URL": "authentication/{validEmailToken}"
    }
  },
  {
    "Name": "Login",
    "Controller": "Authentication",
    "Action": "Login",
    "fr": {
      "URL": "identification"
    },
    "en": {
      "URL": "authentication"
    }
  },
  {
    "Name": "LoginFromFacebook",
    "Controller": "Authentication",
    "Action": "LoginFromFacebook",
    "fr": {
      "URL": "identification-facebook"
    },
    "en": {
      "URL": "authentication-facebook"
    }
  },
  {
    "Name": "AccountHome",
    "Controller": "AccountHome",
    "Action": "AccountHome",
    "fr": {
      "URL": "mon-compte"
    },
    "en": {
      "URL": "my-account"
    }
  },
  {
    "Name": "AccountUpdate",
    "Controller": "AccountUpdate",
    "Action": "AccountUpdate",
    "fr": {
      "URL": "profil"
    },
    "en": {
      "URL": "profile"
    }
  },
  {
    "Name": "AccountPasswordReset",
    "Controller": "AccountPasswordReset",
    "Action": "AccountPasswordReset",
    "fr": {
      "URL": "mot-de-passe"
    },
    "en": {
      "URL": "password"
    }
  },
  {
    "Name": "AccountOrderTracking",
    "Controller": "AccountOrderTracking",
    "Action": "AccountOrderTracking",
    "fr": {
      "URL": "suivi-de-commande"
    },
    "en": {
      "URL": "order-tracking"
    }
  },
  {
    "Name": "AccountInvoices",
    "Controller": "AccountInvoices",
    "Action": "AccountInvoices",
    "fr": {
      "URL": "factures"
    },
    "en": {
      "URL": "invoices"
    }
  },
  {
    "Name": "AccountClaim",
    "Controller": "AccountClaim",
    "Action": "AccountClaim",
    "fr": {
      "URL": "reclamation"
    },
    "en": {
      "URL": "claim"
    }
  },
  {
    "Name": "AccountReturns",
    "Controller": "AccountReturns",
    "Action": "AccountReturns",
    "fr": {
      "URL": "retours"
    },
    "en": {
      "URL": "returns"
    }
  },
  {
    "Name": "AccountSavedCarts",
    "Controller": "AccountSavedCarts",
    "Action": "AccountSavedCarts",
    "fr": {
      "URL": "paniers-sauvegardes"
    },
    "en": {
      "URL": "saved-cart"
    }
  },
  {
    "Name": "AccountNumericProducts",
    "Controller": "AccountNumericProducts",
    "Action": "Index",
    "fr": {
      "URL": "produits-numeriques"
    },
    "en": {
      "URL": "digital-products"
    }
  },
  {
    "Name": "AccountVouchers",
    "Controller": "AccountVouchers",
    "Action": "Index",
    "fr": {
      "URL": "bons-d-achat"
    },
    "en": {
      "URL": "vouchers"
    }
  },
  {
    "Name": "AccountLoyaltyPoints",
    "Controller": "AccountLoyaltyPoints",
    "Action": "AccountLoyaltyPoints",
    "fr": {
      "URL": "points-fidelite"
    },
    "en": {
      "URL": "loyalty-point"
    }
  },
  {
    "Name": "AccountWishList",
    "Controller": "AccountWishList",
    "Action": "WishList",
    "fr": {
      "URL": "liste-de-souhaits"
    },
    "en": {
      "URL": "wish-list"
    }
  },
  {
    "Name": "AccountMultiWishList",
    "Controller": "AccountWishList",
    "Action": "WishList",
    "fr": {
      "URL": "mes-listes-de-souhaits"
    },
    "en": {
      "URL": "my-wish-list"
    }
  },
  {
    "Name": "AccountQuotations",
    "Controller": "AccountQuotation",
    "Action": "Account",
    "fr": {
      "URL": "devis"
    },
    "en": {
      "URL": "quote"
    }
  },
  {
    "Name": "AccountAdvancedQuotations",
    "Controller": "AccountQuotation",
    "Action": "Account",
    "fr": {
      "URL": "mes-devis"
    },
    "en": {
      "URL": "my-quote"
    }
  },
  {
    "Name": "AccountCredits",
    "Controller": "AccountCredits",
    "Action": "Show",
    "fr": {
      "URL": "avoirs"
    },
    "en": {
      "URL": "credit-note"
    }
  },
  {
    "Name": "AccountGiftCards",
    "Controller": "AccountGiftCards",
    "Action": "AccountGiftCards",
    "fr": {
      "URL": "cheques-cadeaux"
    },
    "en": {
      "URL": "gift-voucher"
    }
  },
  {
    "Name": "AccountSponsorShip",
    "Controller": "AccountSponsorShip",
    "Action": "AccountSponsorShip",
    "fr": {
      "URL": "parrainage"
    },
    "en": {
      "URL": "sponsorship"
    }
  },
  {
    "Name": "Search",
    "Controller": "Search",
    "Action": "Search",
    "fr": {
      "URL": "recherche"
    },
    "en": {
      "URL": "research"
    }
  },
  {
    "Name": "SearchAngular",
    "Controller": "Search",
    "Action": "Search",
    "fr": {
      "URL": "recherche/{q}"
    },
    "en": {
      "URL": "research/{q}"
    }
  },
  {
    "Name": "SearchPageAngular",
    "Controller": "Search",
    "Action": "Search",
    "fr": {
      "URL": "recherche/{q}/{p:int}"
    },
    "en": {
      "URL": "research/{q}/{p:int}"
    }
  },
  {
    "Name": "SortedSearchPageAngular",
    "Controller": "Search",
    "Action": "Search",
    "fr": {
      "URL": "recherche/{q}/{p:int}/{sort:alpha}"
    },
    "en": {
      "URL": "research/{q}/{p:int}/{sort:alpha}"
    }
  },
  {
    "Name": "SortedSearchAngular",
    "Controller": "Search",
    "Action": "Search",
    "fr": {
      "URL": "recherche/{q}/{sort:alpha}"
    },
    "en": {
      "URL": "research/{q}/{sort:alpha}"
    }
  },
  {
    "Name": "SearchProducts",
    "Controller": "Search",
    "Action": "SearchProducts",
    "fr": {
      "URL": "produits"
    },
    "en": {
      "URL": "products"
    }
  },
  {
    "Name": "SearchProductsPageAngular",
    "Controller": "Search",
    "Action": "SearchProducts",
    "fr": {
      "URL": "produits/{p:int}"
    },
    "en": {
      "URL": "products/{p:int}"
    }
  },
  {
    "Name": "SortedSearchProductsAngular",
    "Controller": "Search",
    "Action": "SearchProducts",
    "fr": {
      "URL": "produits/{sort:alpha}"
    },
    "en": {
      "URL": "products/{sort:alpha}"
    }
  },
  {
    "Name": "SortedSearchProductsPageAngular",
    "Controller": "Search",
    "Action": "SearchProducts",
    "fr": {
      "URL": "produits/{p:int}/{sort:alpha}"
    },
    "en": {
      "URL": "products/{p:int}/{sort:alpha}"
    }
  },
  {
    "Name": "Stores",
    "Controller": "Stores",
    "Action": "Stores",
    "fr": {
      "URL": "magasins"
    },
    "en": {
      "URL": "stores"
    }
  },
  {
    "Name": "StoresWebsite",
    "Controller": "Stores",
    "Action": "StoresWebsite",
    "fr": {
      "URL": "liste-magasins"
    },
    "en": {
      "URL": "stores-list"
    }
  },
  {
    "Name": "Contact",
    "Controller": "Form",
    "Action": "Contact",
    "fr": {
      "URL": "contact"
    },
    "en": {
      "URL": "contact"
    }
  },
  {
    "Name": "CatalogRequest",
    "Controller": "Form",
    "Action": "CatalogRequest",
    "fr": {
      "URL": "catalogue"
    },
    "en": {
      "URL": "catalogue"
    }
  },
  {
    "Name": "Jobs",
    "Controller": "Form",
    "Action": "Jobs",
    "fr": {
      "URL": "jobs"
    },
    "en": {
      "URL": "jobs"
    }
  },
  {
    "Name": "MessageCatalogRequest",
    "Controller": "Message",
    "Action": "CatalogRequest",
    "fr": {
      "URL": "Message/Catalogue"
    },
    "en": {
      "URL": "Message/Catalog"
    }
  },
  {
    "Name": "MessageContact",
    "Controller": "Message",
    "Action": "Contact",
    "fr": {
      "URL": "Message/Contact"
    },
    "en": {
      "URL": "Message/Contact"
    }
  },
  {
    "Name": "MessageAccountClaim",
    "Controller": "Message",
    "Action": "Claim",
    "fr": {
      "URL": "Message/Claim"
    },
    "en": {
      "URL": "Message/Claim"
    }
  },
  {
    "Name": "MessageContactAdd",
    "Controller": "Message",
    "Action": "AddContact",
    "fr": {
      "URL": "Message/Add/Contact"
    },
    "en": {
      "URL": "Message/Add/Contact"
    }
  },
  {
    "Name": "MessageCatalogRequestAdd",
    "Controller": "Message",
    "Action": "AddCatalogRequest",
    "fr": {
      "URL": "Message/Add/CatalogRequest"
    },
    "en": {
      "URL": "Message/Add/CatalogRequest"
    }
  },
  {
    "Name": "MessageAccountClaimAdd",
    "Controller": "Message",
    "Action": "AddClaim",
    "fr": {
      "URL": "Message/Add/Reclamation"
    },
    "en": {
      "URL": "Message/Add/Claim"
    }
  },
  {
    "Name": "CartQuotationPaymentList",
    "Controller": "Payment",
    "Action": "PaymentListQuotation",
    "fr": {
      "URL": "devis/choix-paiement/{idFolder:int}"
    },
    "en": {
      "URL": "quote/payment-choice/{idFolder:int}"
    }
  },
  {
    "Name": "PaymentListAdvance",
    "Controller": "Payment",
    "Action": "PaymentListAdvance",
    "fr": {
      "URL": "acompte/choix-paiement/{idFolder:int}/{idAdvance:int}"
    },
    "en": {
      "URL": "advance/payment-choice/{idFolder:int}/{idAdvance:int}"
    }
  },
  {
    "Name": "SellerPage",
    "Controller": "Seller",
    "Action": "Seller",
    "fr": {
      "URL": "{sellerName}-v-{sellerId:int}/{keyMessageType?}"
    },
    "en": {
      "URL": "{sellerName}-v-{sellerId:int}/{keyMessageType?}"
    }
  },
  {
    "Name": "AdvancedReviewsForm",
    "Controller": "AccountAdvancedReviews",
    "Action": "Form",
    "fr": {
      "URL": "avis-articles/{token}"
    },
    "en": {
      "URL": "product-reviews/{token}"
    }
  },
  {
    "Name": "AccountAdvancedReviews",
    "Controller": "AccountAdvancedReviews",
    "Action": "AccountAdvancedReviews",
    "fr": {
      "URL": "avis-articles"
    },
    "en": {
      "URL": "product-reviews"
    }
  },
  {
    "Name": "AccountDedicatedProducts",
    "Controller": "AccountDedicatedProducts",
    "Action": "Show",
    "fr": {
      "URL": "produits-personnalises"
    },
    "en": {
      "URL": "dedicated-products"
    }
  },
  {
    "Name": "UpdateLineQuantityCart",
    "Controller": "Cart",
    "Action": "UpdateLineQuantityCart",
    "fr": {
      "URL": "UpdateLineQuantityCart/{idLine:int}/{RemovedQuantity:int}"
    },
    "en": {
      "URL": "UpdateLineQuantityCart/{idLine:int}/{RemovedQuantity:int}"
    }
  },
  {
    "Name": "Click2Call",
    "Controller": "OVH",
    "Action": "Click2Call",
    "fr": {
      "URL": "clickToCall"
    },
    "en": {
      "URL": "clickToCall"
    }
  },
  {
    "Name": "AlmaCheckEligibility",
    "Controller": "Alma",
    "Action": "AlmaCheckEligibility",
    "fr": {
      "URL": "AlmaCheckEligibility"
    },
    "en": {
      "URL": "AlmaCheckEligibility"
    }
  },
  {
    "Name": "AlmaGetPaymentInfos",
    "Controller": "Alma",
    "Action": "AlmaGetPaymentInfos",
    "fr": {
      "URL": "AlmaGetPaymentInfos"
    },
    "en": {
      "URL": "AlmaGetPaymentInfos"
    }
  },
  {
    "Name": "AlmaGetApiInfos",
    "Controller": "Alma",
    "Action": "AlmaGetApiInfos",
    "fr": {
      "URL": "AlmaGetApiInfos"
    },
    "en": {
      "URL": "AlmaGetApiInfos"
    }
  },
  {
    "Name": "AlmaPrePaymentRequest",
    "Controller": "Alma",
    "Action": "AlmaPrePaymentRequest",
    "fr": {
      "URL": "AlmaPrePaymentRequest"
    },
    "en": {
      "URL": "AlmaPrePaymentRequest"
    }
  },
  {
    "Name": "AlmaConfirm",
    "Controller": "Alma",
    "Action": "AlmaConfirm",
    "fr": {
      "URL": "AlmaConfirm"
    },
    "en": {
      "URL": "AlmaConfirm"
    }
  },
  {
    "Name": "AlmaAsyncResponse",
    "Controller": "Alma",
    "Action": "AlmaAsyncResponse",
    "fr": {
      "URL": "AlmaAsyncResponse"
    },
    "en": {
      "URL": "AlmaAsyncResponse"
    }
  },
  {
    "Name": "Quote",
    "Controller": "Form",
    "Action": "Quote",
    "fr": {
      "URL": "demande-devis"
    }
  },
  {
    "Name": "AggregateCategory",
    "Controller": "Category",
    "Action": "Index",
    "fr": {
      "URL": "{categoryName}-roff-{categoryId:int}"
    }
  }
]);
})();
